import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from '@/i18n'
import * as drawSvg from 'drawsvg';
import vueInlineSvg from 'vue-inline-svg';
import { configAuthInitial } from '@/services/auth'; // Import the configuration function
import { updateDynamicManifest } from '@/pwa/dynamicManifest';

// Vuetify
// import 'vuetify/styles';
// import { createVuetify } from 'vuetify';
// import * as components from 'vuetify/components';
// import * as directives from 'vuetify/directives';
import vuetify from './vuetify';

// Icons (optional but common)
import '@mdi/font/css/materialdesignicons.css';



// Import components and functions
import VueDraggable from 'vuedraggable';
//import { Form, Field, ErrorMessage, defineRule, configure } from 'vee-validate';
//import * as rules from '@vee-validate/rules';



//import {
//  applyPolyfills,
//  defineCustomElements
//} from '@aws-amplify/ui-components/loader'

import { VueCsvImportPlugin } from 'vue-csv-import';
import VuePdfEmbed from 'vue-pdf-embed';

//import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAdd,
  faXmarkCircle,
  faTrash,
  faShoppingCart,
  faLockOpen,
  faLocationCrosshairs,
  faBars,
  faArrowDown,
  faArrowUp,
  faCircleCheck,
  faCheck,
  faUser,
  faUserSlash,
  faEye,
  faEyeSlash,
  faEdit,
  faPlus,
  faMinus,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faSync,
  faPaperclip,
  faDownload,
  faUpload,
  faXmark,
  faSpinner,
  faCircleNotch,
  faCircleInfo,
  faLock,
  faFlag,
  faAngleDown,
  faAngleRight,
  faBarsStaggered,
  faFloppyDisk,
  faCircleChevronLeft,
  faCircleChevronRight,
  faListUl,
  faImage,
  faEllipsisVertical,
  faLocationDot,
  faMapLocationDot,
  faArrowTurnUp,
  faSquarePlus,
  faBookmark,
  faMap,
  faGem,
  faStar,
  faBook,
  faListCheck,
  faUnlock,
  faRoute,
  faMagnifyingGlass,
  faFilePen,
  faMagnifyingGlassPlus,
  faMagnifyingGlassMinus,
  faArrowDownShortWide,
  faArrowUpShortWide,
  faTags,
  faTag,
  faFilter,
  faNoteSticky,
  faClone,
  faScissors,
  faBoxArchive,
  faCoins,
  faEquals,
  faUpLong,
  faDownLong,
  faLightbulb,
  faArrowsRotate,
  faPaperPlane,
  faArrowUpLong,
  faBookOpenReader,
  faDumbbell,
  faClock,
  faBell,
  faLanguage,
  faCloudArrowUp,
  faClockRotateLeft,
  faRotateLeft,
  faTriangleExclamation,
  faRocket,
  faFlagCheckered,
  faHome,
  faUsers,
  faArrowLeft,
  faArrowUpFromBracket,
  faBoxOpen,
  faBullhorn,
  faEnvelope,
  faFaceLaughBeam,
  faFaceSmile,
  faFaceMeh,
  faClipboardQuestion,
  faFolder,
  faCalendar as faCalendarSolid,
  faCircleDot as faCircleDotSolid,
  faMapLocationDot as faMapLocationDotSolid,
} from '@fortawesome/free-solid-svg-icons';
import {
  faCirclePlay,
  faCircleCheck as faCircleCheckRegular,
  faCalendar,
  faCalendarPlus,
  faCircleDot,
  faClock as faClockRegular,
  faCircle,
  faFolderClosed,
  faFolderOpen,
} from '@fortawesome/free-regular-svg-icons';

//applyPolyfills().then(() => {
//  defineCustomElements(window)
//})

//console.log('localstore')
//const getCache = localStorage.getItem('commovis')

// Add icons to library
library.add(
    faAdd,
    faXmarkCircle,
    faTrash,
    faShoppingCart,
    faLockOpen,
    faLocationCrosshairs,
    faBars,
    faArrowDown,
    faArrowUp,
    faCircleCheck,
    faCheck,
    faUser,
    faUserSlash,
    faEye,
    faEyeSlash,
    faEdit,
    faPlus,
    faMinus,
    faChevronDown,
    faChevronRight,
    faChevronLeft,
    faSync,
    faPaperclip,
    faDownload,
    faUpload,
    faXmark,
    faSpinner,
    faCircleNotch,
    faCircleInfo,
    faLock,
    faFlag,
    faAngleDown,
    faAngleRight,
    faBarsStaggered,
    faFloppyDisk,
    faCircleChevronLeft,
    faCircleChevronRight,
    faListUl,
    faImage,
    faEllipsisVertical,
    faLocationDot,
    faMapLocationDot,
    faArrowTurnUp,
    faSquarePlus,
    faBookmark,
    faMap,
    faGem,
    faStar,
    faBook,
    faListCheck,
    faUnlock,
    faRoute,
    faMagnifyingGlass,
    faFilePen,
    faMagnifyingGlassPlus,
    faMagnifyingGlassMinus,
    faArrowDownShortWide,
    faArrowUpShortWide,
    faTags,
    faTag,
    faFilter,
    faNoteSticky,
    faClone,
    faScissors,
    faBoxArchive,
    faCoins,
    faEquals,
    faUpLong,
    faDownLong,
    faLightbulb,
    faArrowsRotate,
    faPaperPlane,
    faArrowUpLong,
    faBookOpenReader,
    faDumbbell,
    faClock,
    faBell,
    faLanguage,
    faCloudArrowUp,
    faClockRotateLeft,
    faRotateLeft,
    faTriangleExclamation,
    faRocket,
    faFlagCheckered,
    faHome,
    faUsers,
    faArrowLeft,
    faArrowUpFromBracket,
    faMapLocationDotSolid,
    faCircleDotSolid,
    faCalendarSolid,
    faBoxOpen,
    faBullhorn,
    faEnvelope,
    faFaceLaughBeam,
    faFaceSmile,
    faFaceMeh,
    faClipboardQuestion,
    faFolder,

    faCirclePlay,
    faCircleCheckRegular,
    faCalendar,
    faCalendarPlus,
    faCircleDot,
    faClockRegular,
    faCircle,
    faFolderClosed,
    faFolderOpen,
);

// const vuetify = createVuetify({
//     components,
//     directives,
// });

async function initializeApp() {
  try {
    // Load tenant information first
    const tenantResult = await store.dispatch('tenant/getTenant');

    // If getTenant returned null (offline with no cache), check if we have tenant info in store
    // This can happen if persistence loaded it but getTenant couldn't use it
    if (!tenantResult && store.state.tenant.tenantinfo && store.state.tenant.tenantinfo.tenantname) {
      console.log('getTenant returned null but tenant info exists in store, using it');
      // Tenant info is already in store from persistence, continue
    } else if (!tenantResult) {
      console.error('Failed to load tenant info and no cached data available');
      // App might not work correctly, but try to continue
    }

    // Update document title and PWA meta tags with tenant name (manifest is served from backend API)
    if (store.state.tenant.tenantinfo && store.state.tenant.tenantinfo.tenantname) {
      updateDynamicManifest(store);
    }

    // Configure Amplify (it will wait for tenant info if needed)
    await configAuthInitial();

    await store.dispatch('uiI18n/bootstrap');

    // Now create the app instance
    const app = createApp(App);



    app.use(store)
    app.use(router)
    app.use(i18n)
    app.use(vuetify)
    app.use(VueCsvImportPlugin)

    app.component('drawSvg', drawSvg)

    app.component('VueDraggable', VueDraggable)
    app.component('vueInlineSvg', vueInlineSvg)
    app.component('VuePdfEmbed', VuePdfEmbed)


    app.component("font-awesome-icon", FontAwesomeIcon)

    app.mount('#app');

  } catch (error) {
    console.error('Error initializing the app:', error);
    // Handle initialization error (e.g., show error message)
  }
}

// Service worker registration is now handled by UpdateCoordinator
// No need to register service workers here anymore

initializeApp(); // Start the initialization




